@if (isReadOnly()) {
  <div class="borderColor mb-2 flex w-full flex-col gap-2 rounded-xl border px-4 py-2 shadow-xl">
    <div class="flex w-full items-center gap-3">
      <div class="relative h-14 w-14 shrink-0 overflow-hidden bg-gray-300 shadow-lg">
        @if (isLoadingFile()) {
          <app-loading />
        } @else {
          <img [src]="previewImageUrl()" class="h-full w-full rounded-lg object-cover shadow-2xl" alt="File Preview" />
        }
      </div>
      <div class="flex w-full items-center justify-between gap-3">
        <h3 class="text-sm font-bold">{{ productTitle() }}</h3>
        <app-item-quantity-status
          [quantity]="quantityString()"
          [packageQuantity]="packageQuantity()"
          [notPackageRows]="notPackageRows()"
          [showOnlyPackaged]="showOnlyPackaged()" />
      </div>
    </div>

    <div class="flex w-full flex-col gap-1.5 border-t border-gray-100 pt-1.5">
      <div class="flex w-full items-center justify-between gap-5 text-[13px] text-gray-600">
        <div class="flex items-center gap-5">
          <span class="flex items-center gap-1">
            <app-customer-price-icon />
            {{ peoplePrice() }}
            <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
          </span>
          <span class="flex items-center gap-1">
            <app-business-price-icon />
            {{ businessPrice() }}
            <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
          </span>
        </div>
      </div>
      <div class="flex w-full items-center justify-between gap-5 text-[13px] text-gray-600">
        <div class="flex items-center gap-5">
          <span class="flex items-center gap-1">
            <app-mfg-exp-dates-icon />
            {{ concatenationDate() }}
          </span>
          <span class="flex items-center gap-1">
            <app-batch-number-icon />
            {{ batchNumber() }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1.5 border-t border-gray-100 pt-3 text-sm">
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPeoplePrice">Total People Price:</span>
        <p class="w-24 text-left">
          {{ totalPeoplePriceComputed().toFixed(2) }}
          <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
        </p>
      </div>
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPharmacyPrice">Total Pharmacy Price:</span>
        <p class="w-24 text-left">
          {{ displayPharmacyPrice().toFixed(2) }}
          <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
        </p>
      </div>
    </div>
  </div>
} @else {
  <div
    class="borderColor relative mb-2 flex flex-col gap-4 rounded-xl border shadow-xl"
    [class.py-4]="!isReadOnly()"
    [class.py-2]="isReadOnly()"
    [class.px-5]="!isReadOnly()"
    [class.px-4]="isReadOnly()">
    <div class="flex w-full items-start justify-between gap-6">
      <div class="relative h-[10.5rem] w-[10.5rem] overflow-hidden bg-gray-300 shadow-lg">
        @if (isLoadingFile()) {
          <app-loading />
        } @else {
          @if (isProductOffer()) {
            <div
              [class.right-0]="isArabic()"
              [class.left-0]="!isArabic()"
              class="absolute top-[-38px] right-[1rem] flex h-full w-[1rem] rotate-[314deg] items-center justify-center bg-blue-500 text-sm text-white">
              <span class="absolute top-[50px] left-[-6px] rotate-[92deg] text-center text-[10px]">
                {{ isArabic() ? "تخفيض" : "discount" }}
              </span>
            </div>
          }
          <img [src]="previewImageUrl()" class="h-full w-full rounded-lg object-cover shadow-2xl" alt="File Preview" />
        }
      </div>

      <div class="w-full">
        <h3
          [class.my-2]="!isReadOnly()"
          [class.my-1]="isReadOnly()"
          [class.text-xl]="!isReadOnly()"
          [class.text-base]="isReadOnly()"
          class="font-bold">
          {{ productTitle() }}
        </h3>
        <div class="w-full">
          <div class="flex flex-col gap-y-2">
            <div class="flex items-center">
              <div class="flex w-32 items-center gap-2">
                <app-customer-price-icon />
                <span>
                  {{ peoplePrice() }}
                  <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
                </span>
              </div>
              <div class="flex items-center gap-2">
                <app-business-price-icon />
                @if (isProductOffer()) {
                  <del class="helperColor">
                    {{ businessPrice() }}
                    <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
                  </del>
                } @else {
                  <span>
                    {{ businessPrice() }}
                    <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
                  </span>
                }
              </div>
            </div>

            <div class="flex items-center">
              <div class="flex w-32 items-center gap-2">
                <app-mfg-exp-dates-icon />
                <span>{{ concatenationDate() }}</span>
              </div>
              <div class="flex items-center gap-2">
                <app-batch-number-icon />
                <span>{{ batchNumber() }}</span>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <app-item-quantity-status
              [quantity]="quantityString()"
              [packageQuantity]="packageQuantity()"
              [notPackageRows]="notPackageRows()"
              [editable]="isPrinted() && !isReadOnly()"
              [isPrinted]="isPrinted() && !isReadOnly()"
              [isPartiallyPackaged]="isPartiallyPackaged()"
              [showOnlyPackaged]="showOnlyPackaged()"
              (open)="onOpenPackageModal()"
              [receiveReturnedProductsView]="receiveReturnedProductsView()" />
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1.5 border-t border-gray-100 pt-3 text-sm">
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPeoplePrice">Total People Price:</span>
        <p class="w-24 text-left">
          {{ totalPeoplePriceComputed().toFixed(2) }}
          <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
        </p>
      </div>
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPharmacyPrice">Total Pharmacy Price:</span>
        <p class="w-24 text-left">
          {{ displayPharmacyPrice().toFixed(2) }}
          <span>{{ isArabic() ? "ج.م" : "EGP" }}</span>
        </p>
      </div>
    </div>

    @if (showShortageActions()) {
      <div class="mt-2 flex items-center justify-end gap-3 border-t border-gray-100 pt-3">
        <button
          type="button"
          (click)="onDropShortage()"
          class="borderTabsColor textTabsColor hover-bg-primary-10 flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl border bg-white px-4 py-2.5 text-sm font-semibold transition-colors">
          <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          {{ isArabic() ? "إزالة من الطلب" : "Drop From Order" }}
        </button>

        @if (!isFullyUnpackaged()) {
          <button
            type="button"
            (click)="onConfirmShortage()"
            class="bgTabsColor hover-bg-primary-hover flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white transition-colors">
            <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
            </svg>
            {{ isArabic() ? "تأكيد" : "Confirm" }}
          </button>
        }
      </div>
    }
  </div>
}
